module.exports = __webpack_public_path__ + "img/vu.b002238b.svg";